export default function linkExtender (
  idAttribute,
  collectionAccessor,
  dispatchGetItemCb,
  internalLinkPath,
  pathName,
  paramName
) {
  return {
    idAttribute,
    selector: `a[${idAttribute}]`,
    dispatch: dispatchGetItemCb,
    processor: (element, config) => {
      const itemId = element.getAttribute(idAttribute)
      const item = collectionAccessor(itemId, config.vm)
      if (item === undefined) return
      element.textContent = item.code || item.longName || item.name || itemId
      element.href = `/#/${internalLinkPath}/${item.id}`
      element.addEventListener('click', (event) => {
        event.preventDefault()
        config.vm.$router.push({ name: pathName, params: { [paramName]: item.id } })
      })
    },
  }
}
